import React from 'react';
import { Translate } from 'react-redux-i18n';

const TypeRadios = React.createClass({
  render() {
    return (
      <div className="form-group" id="search-product-by">
        <label className="col-xs-1" style={{width: '55px', paddingRight: '0px'}}>
          <Translate value="search" />:
        </label>
        {
          this.props.InvoiceNoSearch && (
            <label className="col-xs-2" style={{width: '60px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="invoiceNo"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'invoiceNo'}
              />
              <Translate value="SO_no" />
            </label>
          )
        }
        {
          this.props.TrackingNoSearch && (
            <label className="col-xs-2" style={{width: '78px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="trackingNo"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'trackingNo'}
              />
              <Translate value="track_no" />
            </label>
          )
        }
        <label className="col-xs-2" style={{width: '75px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="ProductNum"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'ProductNum'}
          />
          <Translate value="prod_num" />
        </label>
        <label className="col-xs-2" style={{width: '70px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="RefNum"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'RefNum'}
          />
          <Translate value="ref_num" />
        </label>
        <label className="col-xs-2" style={{width: '60px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="Name"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'Name'}
          />
          <Translate value="name" />
        </label>
        <label className="col-xs-2" style={{width: '60px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="Description"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'Description'}
          />
          <Translate value="desc" />
        </label>
      </div>
    );
  },
});

export default TypeRadios;



// WEBPACK FOOTER //
// ./master/jsx/containers/Common/TypeRadios.jsx